'use client';

import { FormEvent, useState } from 'react';
import Link from 'next/link';
import { PublicShell } from '@/components/layout/PublicShell';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();

    setLoading(true);
    setMessage('');

    try {
      await fetch(`${process.env.NEXT_PUBLIC_API_URL}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      setMessage('Ha ez az email cím regisztrálva van, elküldtük a jelszó-visszaállító linket.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <PublicShell>
      <main className="min-h-screen flex items-center justify-center p-6">
        <form
          onSubmit={handleSubmit}
          className="w-full max-w-md rounded-2xl border p-6 space-y-4 shadow-sm"
        >
          <h1 className="text-2xl font-bold">Elfelejtett jelszó</h1>
          <p className="text-sm text-muted-foreground">
            Add meg az email címed, és küldünk egy linket a jelszavad visszaállításához.
          </p>

          <label className="block space-y-1">
            <span className="text-sm font-medium">Email</span>
            <input
              className="w-full rounded-xl border px-3 py-2"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
            />
          </label>

          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-xl bg-primary text-primary-foreground px-4 py-2 font-medium disabled:opacity-60"
          >
            {loading ? 'Küldés...' : 'Visszaállító link kérése'}
          </button>

          {message && <p className="rounded-xl bg-muted px-3 py-2 text-sm text-foreground">{message}</p>}

          <Link href="/login" className="block text-center text-sm text-muted-foreground underline">
            Vissza a belépéshez
          </Link>
        </form>
      </main>
    </PublicShell>
  );
}
